import { Spin } from '@m4b-design/components';
import React from 'react';
import styles from './index.scss';

interface LoadingProps {
  backgroundColor?: string;
}

const Loading = (props: LoadingProps) => (
  <div className={styles.loading}>
    <Spin style={{ backgroundColor: props.backgroundColor ?? '#f6f6f6' }} />
  </div>
);

export default Loading;
